import {
  API_ROUTES,
  billingOverviewSchema,
  redirectUrlSchema,
  signUpResultSchema,
  type CompleteSetupRequest,
  type SignUpRequest,
  type StartAccountRequest,
} from '@hvac/contracts';
import { queryOptions } from '@tanstack/react-query';
import { z } from 'zod';
import { apiClient } from './queries.js';

/** Sign-up, setup and billing. */

export const billingKeys = { overview: ['billing'] as const };

export const signUp = (body: SignUpRequest) =>
  apiClient.request({
    method: 'POST',
    path: API_ROUTES.account.signUp,
    schema: signUpResultSchema,
    body,
  });

export const requestPasswordReset = (email: string) =>
  apiClient.request({
    method: 'POST',
    path: API_ROUTES.account.passwordReset,
    schema: z.undefined(),
    body: { email },
  });

export const startAccount = (body: StartAccountRequest = {}) =>
  apiClient.request({
    method: 'POST',
    path: API_ROUTES.account.start,
    schema: z.undefined(),
    body,
  });

export const billingOverviewQuery = () =>
  queryOptions({
    queryKey: billingKeys.overview,
    queryFn: ({ signal }) =>
      apiClient.request({
        path: API_ROUTES.billing.overview,
        schema: billingOverviewSchema,
        signal,
      }),
    staleTime: 60_000,
  });

export const startCheckout = () =>
  apiClient.request({
    method: 'POST',
    path: API_ROUTES.billing.checkout,
    schema: redirectUrlSchema,
    body: {},
  });

export const openBillingPortal = () =>
  apiClient.request({
    method: 'POST',
    path: API_ROUTES.billing.portal,
    schema: redirectUrlSchema,
    body: {},
  });

export const completeSetup = (organizationId: string, body: CompleteSetupRequest) =>
  apiClient.request({
    method: 'POST',
    path: API_ROUTES.organizations.setup(organizationId),
    schema: z.undefined(),
    body,
  });

export const setAiCeiling = (organizationId: string, ceilingMinor: string) =>
  apiClient.request({
    method: 'POST',
    path: API_ROUTES.organizations.aiCeiling(organizationId),
    schema: z.undefined(),
    body: { ceilingMinor },
  });
